export default class HttpStatusCodeError extends Error {
  constructor({
    statusCode,
    path,
    message = `Error calling HTTP ${statusCode ? `statusCode ${statusCode}` : undefined}${path ? ` and path ${path}` : undefined}`
  }) {
    super(message)
    this.statusCode = statusCode
    this.path = path
  }
}
